var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolunteers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 400,
    viewBox: "0 0 440 400",
    fill: "none",
    fillOpacity: 0,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M302.781 396.399H130.747C116.664 396.399 105.342 385.081 105.342 371.002V55.4533V28.3984C105.342 14.3189 116.664 3 130.747 3H303.056C317.14 3 328.461 14.3189 328.461 28.3984V371.002C328.185 385.081 316.863 396.399 302.781 396.399Z",
    fill: "none",
    fillOpacity: 1,
    stroke: "currentColor",
    strokeWidth: 4.24011,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.747 380.664C125.5 380.664 121.082 376.247 121.082 371.002V28.3984C121.082 23.1531 125.5 18.7359 130.747 18.7359H303.056C308.303 18.7359 312.721 23.1531 312.721 28.3984V371.002C312.721 376.247 308.303 380.664 303.056 380.664H130.747Z",
    stroke: "currentColor",
    strokeWidth: 1.58717,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.747 372.934C129.642 372.934 128.814 372.106 128.814 371.002V28.3984C128.814 27.2941 129.642 26.4659 130.747 26.4659H303.056C304.161 26.4659 304.989 27.2941 304.989 28.3984V371.002C304.989 372.106 304.161 372.934 303.056 372.934H130.747Z",
    fill: "none",
    fillOpacity: 1,
    stroke: "currentColor",
    strokeWidth: 1.58717,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.342 55.4533H328.185",
    stroke: "currentColor",
    strokeWidth: 1.53349,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.342 341.738H328.185",
    stroke: "currentColor",
    strokeWidth: 1.53349,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M195.087 362.167H238.44",
    stroke: "currentColor",
    strokeWidth: 4.24011,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M222.976 173.887C221.596 173.887 220.491 174.991 220.491 176.372C220.491 177.752 221.596 178.856 222.976 178.856H255.837C258.322 178.856 260.256 176.924 260.256 174.439V161.741C260.256 155.115 256.666 149.593 251.142 146.833C253.076 144.9 254.181 142.139 254.181 139.103C254.181 133.029 249.209 128.336 243.41 128.336C237.335 128.336 232.642 133.306 232.642 139.103C232.642 142.139 233.746 144.9 235.679 146.833C235.403 146.833 235.127 147.108 234.85 147.108C232.641 143.52 229.603 140.483 225.738 138.551C228.5 136.065 230.156 132.752 230.156 128.888C230.156 121.71 224.358 115.913 217.178 115.913C209.999 115.913 204.199 121.71 204.199 128.888C204.199 132.752 205.856 136.065 208.617 138.551C204.752 140.207 201.437 143.243 199.505 147.108C199.229 146.833 198.952 146.833 198.677 146.833C200.61 144.9 201.714 142.139 201.714 139.103C201.714 133.029 196.743 128.336 190.945 128.336C184.87 128.336 180.176 133.306 180.176 139.103C180.176 142.139 181.28 144.9 183.213 146.833C177.691 149.593 174.101 155.391 174.101 161.741V174.439C174.101 176.924 176.033 178.856 178.519 178.856H211.102C212.484 178.856 213.588 177.752 213.588 176.372C213.588 174.991 212.484 173.887 211.102 173.887H202.267V157.324C202.267 149.041 209.169 142.139 217.454 142.139C225.738 142.139 232.642 149.041 232.642 157.324V173.887H222.976ZM243.41 133.306C246.724 133.306 249.209 135.79 249.209 139.103C249.209 142.416 246.724 144.9 243.41 144.9C240.097 144.9 237.612 142.416 237.612 139.103C237.612 136.065 240.097 133.306 243.41 133.306ZM255.009 161.741V173.887H237.335V157.324C237.335 155.391 237.06 153.734 236.783 152.078C244.515 146.833 255.009 152.354 255.009 161.741ZM191.221 133.306C194.535 133.306 197.02 135.79 197.02 139.103C197.02 142.416 194.535 144.9 191.221 144.9C187.908 144.9 185.423 142.416 185.423 139.103C185.423 136.065 187.908 133.306 191.221 133.306ZM197.02 157.324V173.887H179.346V161.741C179.346 152.354 189.84 146.833 197.572 152.078C197.295 153.459 197.02 155.391 197.02 157.324ZM217.178 136.894C212.759 136.894 209.446 133.306 209.446 129.164C209.446 124.747 213.036 121.434 217.178 121.434C221.596 121.434 224.91 125.023 224.91 129.164C224.91 133.306 221.596 136.894 217.178 136.894Z",
    fill: "currentColor",
    fillOpacity: 1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M433.945 211.433C431.183 208.672 426.49 208.672 423.728 211.433L361.874 273.273L325.424 236.832C322.662 234.07 317.968 234.07 315.207 236.832C312.445 239.591 312.445 244.285 315.207 247.046L351.656 283.487L361.874 293.702L372.091 283.487L433.945 221.647C436.707 218.611 436.707 214.194 433.945 211.433Z",
    fill: "white",
    fillOpacity: 1,
    stroke: "currentColor",
    strokeWidth: 4.24011,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.38 88.3055C94.0206 88.3055 81.5944 96.0355 75.2433 107.63C68.616 96.0355 56.1899 88.3055 42.1069 88.3055C21.1204 88.3055 4 105.422 4 126.403C4 131.373 4.8284 136.065 6.76136 140.207C10.3511 152.354 20.5682 171.403 47.3535 194.041L75.2433 219.163L103.133 194.041C129.918 171.678 140.136 152.63 144.001 140.482C145.658 136.065 146.763 131.648 146.763 126.679C146.763 105.422 129.642 88.3055 108.38 88.3055Z",
    fill: "white",
    fillOpacity: 1,
    stroke: "currentColor",
    strokeWidth: 4.24011,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.324 187.967C26.9194 166.709 17.2546 149.041 13.6648 137.998L13.3887 137.446C12.008 133.857 11.1796 130.268 11.1796 126.403C11.1796 109.563 24.7102 96.0357 41.5547 96.0357C52.324 96.0357 62.5411 101.833 68.0638 111.496L74.9672 123.367L81.8707 111.496C87.3934 102.109 97.3343 96.0357 108.38 96.0357C125.224 96.0357 138.755 109.563 138.755 126.403C138.755 130.268 137.926 133.857 136.546 137.446V137.722C132.956 148.765 123.291 166.434 97.8867 187.691L74.9672 208.396L52.324 187.967Z",
    stroke: "currentColor",
    strokeWidth: 1.58717,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M188.736 240.972L171.339 223.58C167.474 219.715 167.474 213.365 171.339 209.5C175.204 205.635 181.556 205.635 185.423 209.5L216.626 240.145",
    stroke: "currentColor",
    strokeWidth: 1.53349,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M244.792 240.972L262.188 223.58C266.054 219.715 266.054 213.365 262.188 209.5C258.322 205.635 251.971 205.635 248.105 209.5L216.626 240.145",
    stroke: "currentColor",
    strokeWidth: 1.53349,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M185.423 209.224C181.28 205.359 174.929 205.359 171.063 209.777C167.474 213.917 168.026 219.991 171.891 223.856L173.824 225.789C166.644 222.476 161.95 215.021 161.95 207.016V176.096C161.95 171.403 158.637 166.986 154.218 166.157C147.868 164.777 142.345 169.746 142.345 175.82V226.617C142.345 228.55 142.896 230.206 144.278 231.586L181.833 275.481C182.936 276.861 183.765 278.794 183.765 280.45V295.082H216.626V239.868L185.423 209.224Z",
    stroke: "currentColor",
    strokeWidth: 4.24011,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M248.105 209.224C252.247 205.359 258.598 205.359 262.464 209.777C266.054 213.917 265.501 219.991 261.636 223.856L259.703 225.789C266.883 222.476 271.577 215.021 271.577 207.016V176.096C271.577 171.403 274.89 166.986 279.309 166.157C285.66 164.777 291.182 169.746 291.182 175.82V226.617C291.182 228.55 290.63 230.206 289.249 231.586L252.247 275.481C251.142 276.861 250.314 278.794 250.314 280.45V295.082H216.626V239.868L248.105 209.224Z",
    stroke: "currentColor",
    strokeWidth: 4.24011,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M175.204 303.087V280.726L137.926 236.832C135.441 234.07 134.061 230.482 134.061 226.616V175.82C134.061 166.157 142.068 158.151 151.733 158.151C152.838 158.151 154.218 158.151 155.323 158.428C163.607 160.083 169.406 167.538 169.406 176.095V200.942C172.167 199.561 175.204 198.734 178.243 198.734C182.936 198.734 187.355 200.667 190.668 203.703L216.626 229.102L242.582 203.703C245.896 200.39 250.314 198.734 255.009 198.734C258.046 198.734 261.083 199.561 263.845 200.942V176.095C263.845 167.538 269.643 160.083 277.928 158.428C279.032 158.151 280.413 158.151 281.517 158.151C291.182 158.151 299.191 166.157 299.191 175.82V226.616C299.191 230.206 297.809 234.07 295.324 236.832L257.771 280.726V303.087H175.204Z",
    stroke: "currentColor",
    strokeWidth: 1.58717,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolunteers);
export default __webpack_public_path__ + "static/media/volunteers.c297613f.svg";
export { ForwardRef as ReactComponent };